<template>
  <div>
    <div id="sidebar"></div>
    <div id="container">
      <div id="current_play_date">{{ current_play_date }}</div>
      <svg id="map">
        <!-- <rect id="map" /> -->
        <!-- <g id="topodata" /> -->
      </svg>
    </div>
    <div id="playControl">
      <el-button v-if="!isPlaying && currentPlayPoint < currentPlayLimit" size="small" type="primary"
        icon="el-icon-video-play" @click="play">播放</el-button>
      <el-button v-else-if="!isPlaying && currentPlayPoint >= currentPlayLimit" size="small" type="warning"
        icon="el-icon-refresh-left" @click="resetPlay">重置</el-button>
      <el-button v-else size="small" type="info" icon="el-icon-video-pause" @click="play">暂停</el-button>

      <!-- <div id="slider"></div> -->
      <!-- <el-slider v-model="slidervalue" :step="10" show-stops></el-slider> -->
      <el-radio-group v-model="playSpeed" size="small">
        <el-radio-button :label="100" border>慢</el-radio-button>
        <el-radio-button :label="50" border>中等</el-radio-button>
        <el-radio-button :label="10" border>快</el-radio-button>
      </el-radio-group>
    </div>
    <el-slider v-model="currentPlayPoint" :min="initialvalues[0]" :max="initialvalues[1]" :format-tooltip="showDate"
      :step="1 / 365.25"></el-slider>
  </div>
</template>

<script>
import { listLaunch, listLaunchSite } from "@/services";
export default {
  name: "launch-history",
  data() {
    return {
      launchsites: [],
      launches: {},
      currentLaunches: [],
      currentStartPoint: 0,
      currentPlayPoint: 0,
      currentPlayLimit: 0,
      isPlaying: false,
      playSpeed: 50,
      playTickRepeatTimeout: null,
      initialvalues: [1957, 2099],
      time_slider: null,
      slidervalue: 0,
      projection: null,
      graticule: null,
      path: null,
      map: null,
      tooltip: null,
    };
  },
  computed: {
    current_play_date: {
      get() {
        let time = this.convertDecimalDate(this.currentPlayPoint);
        return (
          ("0" + time.getDate()).slice(-2) +
          "/" +
          ("0" + (time.getMonth() + 1)).slice(-2) +
          "/" +
          time.getFullYear()
        );
      },
    },
  },
  methods: {
    /**
     * Backend Service API Func Wrapper
     */
    async fetchLaunchSite() {
      this.loading = true;
      const res = await listLaunchSite({ brief: 1, size: 0 });
      this.launchsites = res.data.items;
      this.loading = false;
    },
    async fetchLaunch() {
      this.loading = true;
      const res = await listLaunch();
      this.initialvalues = [
        this.convertDateToDecimal(new Date(res.data.items[0]["date"])),
        this.convertDateToDecimal(
          new Date(res.data.items[res.data.items.length - 1]["date"])
        ),
      ];
      this.currentPlayPoint = this.currentStartPoint = this.initialvalues[0];
      this.currentPlayLimit = this.initialvalues[1];
      res.data.items.forEach((item) => {
        var date_parts = new Date(item["date"]);
        var year = date_parts.getFullYear();
        var month = date_parts.getMonth() + 1;
        var day = date_parts.getDate();

        // Ensure data structure is set up
        if (this.launches[year] == null) {
          this.launches[year] = {};
        }

        if (this.launches[year][month] == null) {
          this.launches[year][month] = {};
        }

        if (this.launches[year][month][day] == null) {
          this.launches[year][month][day] = [];
        }

        this.launches[year][month][day].push(item);
      });
      this.loading = false;
    },
    /**
     * D3 Render Function
     */
    //geo translation on mouse click in map
    click() {
      console.log("click");
      // var latlon = this.projection.invert(d3.mouse(this));
    },
    leapYear(year) {
      return (year % 4 == 0 && year % 100 != 0) || year % 400 == 0;
    },
    convertDecimalDate(decimalDate) {
      var year = parseInt(decimalDate);
      var remainder = decimalDate - year;
      var daysPerYear = this.leapYear(year) ? 366 : 365;
      var milliseconds = remainder * daysPerYear * 24 * 60 * 60 * 1000;
      var yearDate = new Date(year, 0, 1);
      return new Date(yearDate.getTime() + milliseconds);
    },
    convertDateToDecimal(date) {
      var year = date.getFullYear();

      var ms = date.getTime() - new Date(year, 0, 1).getTime();

      var num_days = this.leapYear(year) ? 366 : 365;

      var ms_in_year = num_days * 24 * 60 * 60 * 1000;

      return year + (ms * 1.0) / ms_in_year;
    },
    updateSliderValue(evt, value) {
      // Cut all playback and update values for next play request
      this.pause();
      this.resetPlay();
      this.currentPlayPoint = value;
      this.currentPlayLimit = this.initialvalues[1];

      var mindate = this.convertDecimalDate(value);
      var maxdate = this.convertDecimalDate(this.initialvalues[1]);

      updateSliderPositionAndCurrentDate();
    },
    updateSliderPositionAndCurrentDate() {
      this.time_slider.value(this.currentPlayPoint);
      // updateLaunchSiteOpacities();
    },
    setupHashmarkArea() {
      var pixelWidth = parseInt(d3.select("#slider").style("width"));

      var svg = d3
        .select("#slider")
        .append("svg")
        .attr("id", "hashmark_canvas")
        .attr("height", "20px")
        .attr("width", pixelWidth + "px")
        .style("position", "absolute")
        .style("top", "-22px")
        .style("left", "0px");
    },
    // Adds points for the launches of a given day to the display
    // list, after clearing the previous display
    displayDate(year, month, day) {
      var entries = [];

      // Loads launches from current day's launch data
      if (
        this.launches[year] &&
        this.launches[year][month] &&
        this.launches[year][month][day]
      ) {
        entries = this.launches[year][month][day];
      }

      // Right now this clears the points completely
      // Later we may change it to not clear, and just allow
      // the animation to continue
      this.currentLaunches = [];
      for (var i = 0; i < entries.length; i++) {
        // Just add, since we're not checking tags
        this.currentLaunches.push({
          birthtime: new Date().getTime(),
          info: entries[i],
        });
      }
      // addEntryToLaunchLog(entries[i]);

      // updateSliderPositionAndCurrentDate();
      // redrawLaunchesOnly();
      // updateLaunchSiteOpacities();
    },
    // Plays the sequence of all launches starting at the left slider position
    // and ending at the right slider position. This function will loop
    // indefinitely, until the right slider position is reached
    playTick() {
      // Stop playing if we're at the right slider position
      if (this.currentPlayPoint >= this.currentPlayLimit) {
        this.pause();
        // this.resetPlay();
      }

      if (this.isPlaying) {
        // Increment date
        this.currentPlayPoint += 1.0 / 365.25;
        const currentDate = this.convertDecimalDate(this.currentPlayPoint);

        // Update displayed launches (getMonth() returns a value from 0 to 11, so we increment it)
        this.displayDate(
          currentDate.getFullYear(),
          currentDate.getMonth() + 1,
          currentDate.getDate()
        );
        this.drawLaunchEvents();
        // this.updateSliderPositionAndCurrentDate();
        // This function will be called again in {playSpeed} ms
        this.playTickRepeatTimeout = setTimeout(this.playTick, this.playSpeed);
      }
    },
    addLaunchSite(lat, lon, text) {
      //offsets for tooltips
      var offsetL = 20;
      var offsetT = 10;

      var gpoint = this.map.append("g").attr("class", "gpoint");
      var x = this.projection([lat, lon])[0];
      var y = this.projection([lat, lon])[1];
      var ix = x;
      var iy = y;
      // these are special cased because the launch sites overlap
      // on the map.
      if (text.indexOf("Tanegashima") == 0) {
        iy += 10;
      } else if (text.indexOf("Uchinoura") == 0) {
        iy -= 10;
        ix += 5;
      }
      var interactionArea = gpoint
        .append("svg:circle")
        .attr("cx", ix)
        .attr("cy", iy)
        .attr("r", 10)
        .style("fill", "rgba(0,0,0,0)"); // change opacity to 1 to see the interaction area

      gpoint
        .append("svg:circle")
        .attr("cx", x)
        .attr("cy", y)
        .attr("r", 3)
        .attr("id", "launchsite")
        .attr("name", text)
        .style("opacity", 0.2)
        .style("fill", "#04CCFF");

      // gpoint
      //   .on("mousemove", function(d, i) {
      //     var mouse = d3.mouse(this.map.node()).map(function(d) {
      //       return parseInt(d);
      //     });

      //     this.tooltip
      //       .attr("hidden", false)
      //       .attr(
      //         "style",
      //         "left:" +
      //           (mouse[0] + offsetL) +
      //           "px;top:" +
      //           (mouse[1] + offsetT) +
      //           "px"
      //       )
      //       .html(text);
      //   })
      //   .on("mouseout", function(d, i) {
      //     this.tooltip.attr("hidden", true);
      //   });
    },
    addLaunchEvent(lat, lon, status) {
      const status_color = { launch_success: "#4CFF3F", launch_failure: "#FF2A46" };
      var x = this.projection([lat, lon])[0];
      var y = this.projection([lat, lon])[1];

      var circle = this.map
        .append("svg:circle")
        .attr("cx", x)
        .attr("cy", y)
        .attr("class", "point")
        .attr("r", 15)
        .attr("style", "pointer-events: none")
        .attr("style", "fill: " + status_color[status]);

      circle
        .transition()
        .duration(1000)
        .attr("r", 100)
        .style("opacity", "0.0")
        .remove();
    },
    drawMap(world) {
      // Add countries
      this.map
        .selectAll(".country")
        .data(topojson.feature(world, world.objects.countries).features)
        .enter()
        .insert("path")
        .attr("class", "country")
        .attr("d", this.path)
        .attr("id", function (d, i) {
          return d.id;
        })
        .attr("title", function (d, i) {
          return d.properties.name;
        })
        .style("fill", "#606060");
    },
    drawLaunchSites() {
      // Add launch sites
      let site;
      for (var i = 0; i < this.launchsites.length; i++) {
        site = this.launchsites[i];
        this.addLaunchSite(site.longitude, site.latitude, site.description);
      }
    },
    drawLaunchEvents() {
      // Could remove old launches here
      for (var i = 0; i < this.currentLaunches.length; i++) {
        let info = this.currentLaunches[i].info;
        let status =
          info.status == "发射成功" ? "launch_success" : "launch_failure";
        this.addLaunchEvent(info.longitude, info.latitude, status);
      }
    },
    /**
     * UI Control
     */
    // Starts playing a sequence of launches at a specified interval
    play() {
      if (this.isPlaying) {
        this.isPlaying = false;
        clearTimeout(this.playTickRepeatTimeout);
      } else {
        this.isPlaying = true;
        this.playTick();
      }
    },
    // Pauses playing of launch sequences
    pause() {
      this.isPlaying = false;
      clearTimeout(this.playTickRepeatTimeout);
    },
    handlePlayButton() {
      if (!this.isPlaying) {
        this.play(this.playSpeed);
      } else {
        this.pause();
        resetPlay();
      }
    },
    resetPlay() {
      this.currentPlayPoint = this.initialvalues[0];
    },
    showDate(val) {
      let time = this.convertDecimalDate(this.currentPlayPoint);
      return (
        ("0" + time.getDate()).slice(-2) +
        "/" +
        ("0" + (time.getMonth() + 1)).slice(-2) +
        "/" +
        time.getFullYear()
      );
    },
  },
  mounted() {
    // 请求数据
    this.fetchLaunch();

    // d3.js 全局变量初始化，不可放在data中
    this.projection = d3.geoMercator();
    this.graticule = d3.geoGraticule();
    this.path = d3.geoPath().projection(this.projection);
    this.tooltip = d3
      .select("#container")
      .append("div")
      .attr("class", "tooltip hidden");
    const width = document.getElementById("container").clientWidth;
    const height = width / 2;
    this.slidervalue = this.initialvalues[0];

    // d3 绑定页面元素
    this.map = d3.select("#map");

    // set map width and height
    this.map
      .attr("width", width)
      .attr("height", height)
      .on("click", this.click);

    this.projection
      .translate([width / 2, height / 1.4])
      .scale(width / 2 / Math.PI);

    // const g = svg.append("g");
    d3.json("world-topo-min.json")
      .then(this.drawMap)
      .then(this.fetchLaunchSite)
      .then(this.drawLaunchSites);
  },
};
</script>
<style lang="stylus" scoped>
#container {
  position: relative;
}

#current_play_date {
  position: absolute;
  left: 10px;
  bottom: 10px;
  color: #ffffff;
}

#map {
  background: #000;
}

.country {
  fill: rgb(96, 96, 96);
  stroke: #000;
  stroke-width: 0.1px;
}

.launch_success {
  fill: #4CFF3F;
}

.launch_failure {
  fill: #FF2A46;
}

#playControl {
  display: flex;
  justify-content: space-between;
}
</style>
